import { render } from "./ClosetClothingFormView.vue?vue&type=template&id=6686aead&ts=true"
import script from "./ClosetClothingFormView.vue?vue&type=script&lang=ts"
export * from "./ClosetClothingFormView.vue?vue&type=script&lang=ts"

import "./ClosetClothingFormView.vue?vue&type=style&index=0&id=6686aead&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__